import * as React from "react"

export default function LinkIcon(props) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1316_30810)">
        <path
          d="M15.303 12.947l-1.178-1.18 1.178-1.179a4.167 4.167 0 10-5.892-5.892L8.232 5.875 7.053 4.697l1.18-1.179a5.834 5.834 0 018.25 8.25l-1.179 1.179zm-2.356 2.356l-1.18 1.179a5.834 5.834 0 01-8.25-8.25l1.18-1.179 1.178 1.18-1.178 1.179a4.166 4.166 0 105.892 5.892l1.178-1.178 1.18 1.178zm-.59-8.839l1.179 1.18-5.893 5.891-1.179-1.178 5.893-5.892z"
          fill={props.fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_1316_30810">
          <path fill="#fff" d="M0 0H20V20H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}
